import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    text: {
        color: theme.palette.primary.main,
        fontSize: '10px',
        fontWeight: 600,
    },
    separator: {
        fontSize: '12px',
        color: theme.palette.grey.main,
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: '16px',
        marginBottom: '-2px',
    },
}));
